import { MediaInfo, MediaSegment } from "../../../domain/media";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ICommonUtilInterface } from "../../../domain/common/common-util.interface";

export class MediaSegmentsViewModel {
  public timeCodeFieldStyle = {
    height: "30px",
    "line-height": "20px",
    "font-size": "27px",
    width: "169px",
  };
  public showActionButtons = true;
  public fieldsEditable = true;
  public rowsMultiselect = true;
  public timeCodeType: "FPS" | "MS" = "MS";
  public segmentsVM: SegmentViewModel[] = [];
  public cancelButtonClicked = new EventEmitter<void>();
  public applyButtonClicked = new EventEmitter<void>();
  public seekPlayerToTime = new EventEmitter<number>();
  private _maxSegmentId = 0;
  private _qcPreviewCurrentTimeMs = 0;
  showCancelButton = false;
  showApplyButton = false;

  constructor(
    private _media: MediaInfo,
    // public useVitcOfMedia: boolean,
    private _commonUtils: ICommonUtilInterface,
  ) {
    if (_media.segments.length > 0) {
      this._maxSegmentId = Math.max(
        ..._media.segments.map((s) => s.tenantUniqueId),
      );
      this.segmentsVM.push(
        ..._media.segments.map((s) => {
          const segmentVM = new SegmentViewModel(s);
          /*if (useVitcOfMedia) {
          segmentVM.timeInMs += _media.startTimeStampMs;
          segmentVM.timeOutMs += _media.startTimeStampMs;
        }*/
          return segmentVM;
        }),
      );
    }
  }
  public addNewSegmentClickedEventHandler() {
    const startTime = this._qcPreviewCurrentTimeMs;
    const duration = this._media.contentMediaDurationMs;
    /*if (this.useVitcOfMedia) {
      startTime += this._media.startTimeStampMs;
      duration += this._media.startTimeStampMs;
    }*/
    this.segmentsVM.push(
      new SegmentViewModel(
        new MediaSegment(
          this._media,
          this._maxSegmentId + 1,
          this._commonUtils.generateGuid(),
          "",
          startTime,
          duration,
        ),
      ),
    );
    this._maxSegmentId += 1;
  }
  public deleteButtonClickedEventHandler() {
    this.segmentsVM = this.segmentsVM.filter((s) => !s.selected);
  }
  public unselectRows() {
    this.segmentsVM.forEach((s) => (s.selected = false));
    console.log(
      "media-segmnets-view-model->unselectRows",
      this.segmentsVM.map((s) => s.selected),
    );
  }
  public timeCodeTypeButtonClickedEventHandler() {
    if (this.timeCodeType === "MS") {
      this.timeCodeType = "FPS";
    } else {
      this.timeCodeType = "MS";
    }
  }
  public setQcPreviewCurrentTimeMs(newValue: number) {
    const roundedValue = Math.floor(newValue);
    console.log(
      "media-segments-view-model->setDefaultStartTimeMs",
      newValue,
      roundedValue,
    );
    if (this._media.contentMediaDurationMs > roundedValue) {
      this._qcPreviewCurrentTimeMs = roundedValue;
    }
  }
  public toSegments(): MediaSegment[] {
    return [
      ...this.segmentsVM.map((s) => {
        const timeInMs = s.timeInMs;
        const timeOutMs = s.timeOutMs;
        /*if (this.useVitcOfMedia) {
        timeInMs -= this._media.startTimeStampMs;
        timeOutMs -= this._media.startTimeStampMs;
      }*/
        return new MediaSegment(
          s.parentMedia,
          s.tenantUniqueId,
          s.uid,
          s.description,
          timeInMs,
          timeOutMs,
        );
      }),
    ];
  }

  checkboxSelectedEventHandler(segmentVm: SegmentViewModel) {
    const newSelectedValue = !segmentVm.selected;
    if (!this.rowsMultiselect) {
      this.unselectRows();
    }
    segmentVm.selected = newSelectedValue;
  }

  cancelButtonClickedEventHandler() {
    this.cancelButtonClicked.emit();
  }

  applyButtonClickedEventHandler() {
    this.applyButtonClicked.emit();
  }

  setStartTimeToSegment(segmentVm: SegmentViewModel) {
    if (segmentVm.timeOutMs < this._qcPreviewCurrentTimeMs) {
      alert("Can't set TC IN bigger than TC OUT");
    } else {
      segmentVm.timeInMs = this._qcPreviewCurrentTimeMs;
    }
  }

  setEndTimeToSegment(segmentVm: SegmentViewModel) {
    if (segmentVm.timeInMs > this._qcPreviewCurrentTimeMs) {
      alert("Can't set TC OUT less than TC IN");
    } else {
      segmentVm.timeOutMs = this._qcPreviewCurrentTimeMs;
    }
  }
  SeekPlayerToTime(timeMs: number) {
    this.seekPlayerToTime.emit(timeMs);
  }
}
export class SegmentViewModel extends MediaSegment {
  constructor(
    segment: MediaSegment,
    public selected = false,
  ) {
    super(
      segment.parentMedia,
      segment.tenantUniqueId,
      segment.uid,
      segment.description,
      segment.timeInMs,
      segment.timeOutMs,
    );
  }
}
